<template>
	<div>
		<p class="view_head">申报单位信息</p>

		<div style="display: flex;flex-wrap: wrap;">
			<div class="qc_list" style="width: 100%;">
				<p><span style="color: red;">*</span> 推荐单位:</p>
				<div class="qc_list__Right">
					<el-select v-model="newform.recommend_unit" style="width: 350px;"
						@change="labelInput(newform.recommend_unit,'recommend_unit')" placeholder="请选择">
						<el-option v-for="item in options" :key="item.company_code" :label="item.name"
							:value="item.company_code">
						</el-option>
					</el-select>
				</div>
			</div>
			<labelInput :outInput="newform.company_name" :spanRequired="true" normalPlace="请输入申报企业名称"
				@inputChange="labelInput($event,'company_name')" spanTitle="申报企业名称" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<div style="display: flex;align-items: center;height: 40px;width: 93%;">
				<!--  -->
				<label-select ref="labelAddres" componentWidth="550px" :spanRequired="true"
					@placeInfo="place1Info($event,'[province,city,area]')" @placeLevel="tongLevel = $event"
					:spanWidth="spanWidth" spanTitle="申报企业通讯地址">
				</label-select>
				<el-input v-model="newform.address" @blur="emitInput" style="width: 520px;margin-left: 40px;"
					placeholder="请输入详细地址">
				</el-input>
			</div>
			<labelInput :outInput="newform.enp_contact_name" :spanRequired="true" normalPlace="请填写单位联系人"
				@inputChange="labelInput($event,'enp_contact_name')" spanTitle="申报企业联系人" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.enp_contact_phone" :spanRequired="true" normalPlace="请输入申报企业联系电话"
				@inputChange="labelInput($event,'enp_contact_phone')" spanTitle="申报企业联系电话" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
		</div>

		<p class="view_head">建造师项目经理信息</p>
		<div style="display: flex;flex-wrap: wrap;">
			<labelInput :outInput="newform.real_name" :spanRequired="true" normalPlace="请输入姓名"
				@inputChange="labelInput($event,'real_name')" spanTitle="姓名" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<div class="qc_list">
				<p><span style="color: red;">*</span> 性别:</p>
				<div class="qc_list__Right">
					<el-select v-model="newform.sex" style="width: 350px;" @change="labelInput(newform.sex,'sex')"
						placeholder="请选择">
						<el-option v-for="item in agents" :key="item.value" :label="item.name" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
			<datePicker ref="datepicker1" :spanRequired="true" spanTitle="出生年月" pelaceHolder='请选择'
				componentWidth="520px" :spanWidth="spanWidth" @selectDate="labelInput($event,'birth_date')">
			</datePicker>
			<labelInput :outInput="newform.politic" :spanRequired="true" normalPlace="请输入政治面貌"
				@inputChange="labelInput($event,'politic')" spanTitle="政治面貌" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.id_card" specilType='limit' :maxLimit="18" :spanRequired="true"
				normalPlace="请输入身份证号" @inputChange="labelInput($event,'id_card')" spanTitle="身份证号"
				:spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<div class="qc_list">
				<p><span style="color: red;">*</span> 专业技术职称:</p>
				<div class="qc_list__Right">
					<el-select v-model="newform.title" style="width: 350px;" @change="labelInput($event,'title')"
						placeholder="请选择">
						<el-option v-for="item in technicos" :key="item.value" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
				</div>
			</div>
			<!-- <labelInput :outInput="newform.title" :spanRequired="true" normalPlace="请输入专业技术职称"
				@inputChange="labelInput($event,'title')" spanTitle="专业技术职称" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput> -->
			<div class="qc_list">
				<p><span style="color: red;">*</span> 最高学历:</p>
				<div class="qc_list__Right">
					<el-select v-model="newform.education" style="width: 350px;"
						@change="labelInput($event,'education')" placeholder="请选择">
						<el-option v-for="item in educations" :key="item.value" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
				</div>
			</div>
			<labelInput :outInput="newform.major" :spanRequired="true" normalPlace="请输入所学专业"
				@inputChange="labelInput($event,'major')" spanTitle="所学专业" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<labelInput :outInput="newform.post" :spanRequired="true" normalPlace="请输入职务"
				@inputChange="labelInput($event,'post')" spanTitle="职务" :spanWidth="spanWidth" componentWidth="520px">
			</labelInput>
			<!--<datePicker ref="datepicker2" normalDate="month" valueFormat="yyyy-MM" :spanRequired="true" spanTitle="工作年限"
				pelaceHolder='请选择' componentWidth="520px" :spanWidth="spanWidth"
				@selectDate="labelInput($event,'join_work_time')">
			</datePicker>-->
			<labelInput :outInput="newform.join_work_time" :spanRequired="true" normalPlace="请输入工作年限"
				@inputChange="labelInput($event,'join_work_time')" spanTitle="工作年限" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<!-- <div class="qc_clumView">
				<p style="margin-left: -170px;"><span style="color: red;">*</span> 建造师资质等级及主项专业:</p>
				<div class="qc_clumView_right">
					<el-input type="textarea" :rows="2" placeholder="请输入建造师资质等级及主项专业"
						@blur="labelInput(newform.level,'level')" v-model="newform.level">
					</el-input>
				</div>
			</div> -->
			<div class="qc_list">
				<p><span style="color: red;">*</span> 建造师等级:</p>
				<div class="qc_list__Right">
					<!-- v-model="newform.title" -->
					<el-select v-model="newform.level" style="width: 350px;" @change="selectOne" placeholder="请选择">
						<el-option v-for="item in jzsLevel" :key="item.value" :label="item.name" :value="item.name">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="qc_list">
				<p><span style="color: red;">*</span> 建造师专业:</p>
				<div class="qc_list__Right">
					<el-select v-model="construct_major" style="width: 350px;" @change="selectTwo" placeholder="请选择">
						<el-option v-for="item in jzsProfessional" :key="item.value" :label="item.name"
							:value="item.name">
						</el-option>
					</el-select>
				</div>
			</div>
			<labelInput :outInput="newform.req_num" :spanRequired="true" normalPlace="请输入注册证书编号"
				@inputChange="labelInput($event,'req_num')" spanTitle="注册证书编号" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput>
			<!-- <labelInput :outInput="newform.certificate_num" :spanRequired="true" normalPlace="请输入继续教育证书编号"
				@inputChange="labelInput($event,'certificate_num')" spanTitle="继续教育证书编号" :spanWidth="spanWidth"
				componentWidth="520px">
			</labelInput> -->
			<div class="qc_clumView" style="padding-left: 50px;">
				<p><span style="color: red;">*</span> 个人照片上传(2寸证件照):</p>
				<div class="qc_clumView_right">
					<el-upload class="avatar-uploader" action="" :http-request="httpRequest" :show-file-list="false"
						:on-success="handleAvatarSuccess">
						<img :src="imageUrl" v-if="imageUrl">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import {
		client
	} from '@/libs/oss.js'
	import labelInput from '../../../components/table/labelInput.vue'
	import datePicker from '../../../components/table/datePicker.vue'
	import labelSelect from '../../../components/table/labelSelect.vue'
	import {
		getRecomCompany
	} from '../../../api/moudles/user.js'
	export default {
		data() {
			return {
				construct_major: '',
				jzsTitle: '',
				jzsLevel: [{
					name: '一级建造师',
					value: '一级建造师'
				}, {
					name: '二级建造师',
					value: '二级建造师'
				}],
				jzsProfessional: [],
				professionalOne: [{
					name: '建筑工程',
					value: '建筑工程'
				}, {
					name: '机电工程',
					value: '机电工程'
				}, {
					name: '矿业工程',
					value: '矿业工程'
				}, {
					name: '公路工程',
					value: '公路工程'
				}, {
					name: '水利水电工程',
					value: '水利水电工程'
				}, {
					name: '市政公用工程',
					value: '一市政公用工程建'
				}, {
					name: '港口与航道工程',
					value: '港口与航道工程'
				}, {
					name: '铁路工程',
					value: '铁路工程'
				}, {
					name: '民航机场工程',
					value: '民航机场工程'
				}, {
					name: '通信与广电工程',
					value: '通信与广电工程'
				}],
				professionalTwo: [{
					name: '建筑工程',
					value: '建筑工程'
				}, {
					name: '机电工程',
					value: '机电工程'
				}, {
					name: '矿业工程',
					value: '矿业工程'
				}, {
					name: '公路工程',
					value: '公路工程'
				}, {
					name: '水利水电工程',
					value: '水利水电工程'
				}, {
					name: '市政公用工程',
					value: '一市政公用工程建'
				}, ],

				// 头像上传
				imageUrl: '',
				agents: [{
					name: '男',
					value: '1'
				}, {
					name: '女',
					value: '2'
				}],
				education: '',
				technicos: [{
					name: '正高级',
					value: '正高级'
				}, {
					name: '副高级',
					value: '副高级'
				}, {
					name: '中级',
					value: '中级'
				}, {
					name: '助理级',
					value: '助理级'
				}],
				educations: [{
					name: '博士',
					value: '1'
				}, {
					name: '硕士',
					value: '2'
				}, {
					name: '本科',
					value: '3'
				}, {
					name: '大专',
					value: '4'
				}, {
					name: '高中',
					value: '5'
				}, {
					name: '中专/中技',
					value: '6'
				}, {
					name: '初中及以下',
					value: '7'
				}, ],
				newform: {},
				spanWidth: '150px',
				// 推荐单位
				options: [],
			}
		},
		components: {
			labelInput,
			datePicker,
			labelSelect,
		},
		mounted() {
			this.getRecomCompany(this.project_code)
		},
		props: {
			datas: {
				type: Object,
				default: () => {}
			},
			project_code: {
				type: String,
				default: ''
			}
		},
		watch: {
			datas(newValue) {
				if (newValue) {
					this.newform = {
						...newValue
					}
					this.$refs.labelAddres.refAddData([newValue.province ? newValue.province : '',
						newValue.city ? newValue.city : ''
					])
					if (newValue.level == '一级建造师') {
						this.jzsProfessional = this.professionalOne
					} else {
						this.jzsProfessional = this.professionalTwo
					}
					this.construct_major = newValue.construct_major
					this.$refs.datepicker1.setTime(newValue.birth_date)
					// this.$refs.datepicker2.setTime(newValue.join_work_time)
					this.imageUrl = newValue.headImg
				}
			}
		},
		methods: {
			// 选择一级建造师二建
			selectOne(e) {
				if (e == '一级建造师') {
					this.jzsProfessional = this.professionalOne
				} else {
					this.jzsProfessional = this.professionalTwo
				}
				// 选项置空
				this.construct_major = ''

				// 在此处提交一级建造师二建
				this.$emit('reciveData', ['level', e])
			},
			selectTwo(e) {
				// 此处传递 专业的值
				this.$emit('reciveData', ['construct_major', e])
			},
			emitInput() {
				this.$emit('reciveData', ['address', this.newform.address])
			},
			handleAvatarSuccess() {
				// this.getList()
			},
			httpRequest({
				file
			}) {
				const ossPath = localStorage.getItem('ossPath')
				const fileName = ossPath + `/项目申报/优秀项目经理/${Date.parse(new Date())}/${file.name}`; //定义唯一的文件名
				client.put(fileName, file).then(({
					res,
					url,
					name
				}) => {
					if (res && res.status == 200) {
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.imageUrl = url
						this.newform.headImg = url
						this.$emit('reciveData', ['headImg', url])
					}
				}).catch((err) => {
					console.log(`阿里云OSS上传失败回调`, err);
				});
			},
			async getRecomCompany(project_code) {
				let params = {
					project_code
				}
				await getRecomCompany({
					data: params,
					success: res => {
						this.options = res.data
					}
				})
			},
			labelInput(e, name) {
				// console.log(e, name)
				this.newform[name] = e
				this.$emit('reciveData', [name, e])
			},
			place1Info(e, name) {
				if (e.length > 1) {
					// [province,city,area]
					this.newform['province'] = e[0]
					this.newform['city'] = e[1]
					this.$emit('reciveData', ['province', e[0]])
					this.$emit('reciveData', ['city', e[1]])
				}
			},
		}
	}
</script>

<style scoped>
	.avatar-uploader img {
		max-width: 350px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.view_head {
		font-size: 18px;
		font-weight: bold;
		margin-top: 20px;
	}

	.qc_list {
		display: flex;
		align-items: center;
		margin: 10px;
	}

	.qc_clumView {
		width: 100%;
		display: flex;
		flex-flow: column;
		margin: 10px;
		padding-left: 170px;
	}

	.qc_newAdd {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 92%;
		margin-bottom: 10px;
	}

	.qc_clumView p {
		text-align: left;
		font-size: 14px;
		display: inline-block;
		margin-bottom: 10px;
	}

	.qc_clumView_right {
		width: calc(100% - 70px);
	}

	.qc_list__Right {
		padding-left: 20px;
	}

	.qc_list p {
		font-size: 14px;
		width: 150px;
		text-align: right;
		display: inline-block;
	}
</style>
